import { Account, AccountBalance, Balance } from 'vopay';

const EMPTY_BALANCE: Balance = {
  Currency: 'CAD',
  AccountBalance: '0.00',
  AvailableBalance: '0.00',
  AvailableImmediately: '0.00',
  PendingBalance: '0.00',
  Reserve: '0.00',
};

/**
 * The header cards take the list's row shape: the account with one currency's balance folded in.
 * The requested currency wins, then the account's first balance, then zeros for an account the
 * backend returned no balance for at all.
 */
export default function toAccountBalance(account: Account, currency: string | null): AccountBalance {
  const { Balances, ...rest } = account;

  const balance =
    Balances.find((candidate) => candidate.Currency === currency) ??
    (Balances.length > 0 ? Balances[0] : EMPTY_BALANCE);

  return { ...rest, ...balance, SubAccounts: [] };
}
